"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var SidebarPopover_1 = __importDefault(require("../SidebarPopover"));
var SidebarPopoverButton_1 = __importDefault(require("../SidebarPopoverButton"));
var SidebarButtonHeader_1 = __importDefault(require("../SidebarButtonHeader"));
var DropdownFooter_1 = __importDefault(require("../../../DropdownFooter"));
var SidebarDropdownFooter = styled_components_1.default(DropdownFooter_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-top: 1px solid ", ";\n  ", ";\n  ", ";\n"], ["\n  border-top: 1px solid ", ";\n  ", ";\n  ", ";\n"])), style_utils_1.getSidebarColor(50), style_utils_1.setMargin("top", 2), style_utils_1.setPadding("top", 2));
var SidebarButtonPopover = function (_a) {
    var as = _a.as, active = _a.active, activeChild = _a.activeChild, bottom = _a.bottom, children = _a.children, containerRef = _a.containerRef, footer = _a.footer, target = _a.target, isOpen = _a.isOpen, isUserButton = _a.isUserButton, onClick = _a.onClick, subButtons = _a.subButtons, toggle = _a.toggle, trigger = _a.trigger, props = __rest(_a, ["as", "active", "activeChild", "bottom", "children", "containerRef", "footer", "target", "isOpen", "isUserButton", "onClick", "subButtons", "toggle", "trigger"]);
    var onKeyDown = function (e) {
        var _a;
        if (e.key === "ArrowLeft") {
            (_a = document.getElementById(target)) === null || _a === void 0 ? void 0 : _a.focus();
        }
        if (e.key === "Escape" || e.key === "Esc") {
            window.escapedSidebarPopover = true;
        }
    };
    if (children) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(SidebarPopover_1.default, { active: active, bottom: bottom, containerRef: containerRef, isOpen: isOpen, target: target, toggle: toggle, trigger: trigger, onMouseLeave: toggle, onFocus: toggle, onBlur: toggle, onKeyDown: onKeyDown },
                subButtons ? (react_1.default.createElement(SidebarButtonHeader_1.default, __assign({ innerAs: as, isUserButton: isUserButton }, props), children)) : (react_1.default.createElement(SidebarPopoverButton_1.default, __assign({ innerAs: as, active: active, onClick: onClick }, props), children)),
                subButtons &&
                    subButtons.map(function (button, idx) {
                        var key = "subbutton-" + idx;
                        var btnAs = button.as, otherButton = __rest(button, ["as"]);
                        return (react_1.default.createElement(SidebarPopoverButton_1.default, __assign({}, otherButton, { innerAs: btnAs, key: key })));
                    }),
                footer && (react_1.default.createElement(SidebarDropdownFooter, { justifyContent: null }, footer)))));
    }
    return null;
};
exports.default = SidebarButtonPopover;
var templateObject_1;
//# sourceMappingURL=index.js.map